module.exports = __webpack_public_path__ + "static/office_14-c78738f9162ed3b8dd387f6554b535fc.jpg";